import { getConfig, camelCaseObject } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import { logError } from '@edx/frontend-platform/logging';
import { stringify } from 'query-string';

import {
  FEEDBACK_REASON_BROKEN,
  FEEDBACK_REASON_HARMFUL,
  FEEDBACK_REASON_NOT_ACCURATE,
  FEEDBACK_REASON_OTHER,
} from '../feedback-widget/FeedbackDetailsModal';

export const translateXblockUrl = ({ courseId }) => (
  `${
    getConfig().LMS_BASE_URL
  }/api/translatable_xblocks/config/?course_id=${encodeURIComponent(courseId)}`
);

export const fetchFeedbackUrl = ({ params }) => (
  `${
    getConfig().AI_TRANSLATIONS_URL
  }/api/v1/whole-course-translation-feedback/?${params}`
);

export const fetchTranslationConfig = async (courseId) => {
  const url = translateXblockUrl({ courseId });
  try {
    const { data } = await getAuthenticatedHttpClient().get(url);
    return {
      enabled: data.feature_enabled,
      availableLanguages: camelCaseObject(data.available_translation_languages) || [],
    };
  } catch (error) {
    logError(`Translation plugin fail to fetch from ${url}`, error);
    return {
      enabled: false,
      availableLanguages: [],
    };
  }
};

export async function getTranslationFeedback({
  courseId,
  translationLanguage,
  unitId,
  userId,
}) {
  const params = stringify({
    translation_language: translationLanguage,
    course_id: encodeURIComponent(courseId),
    unit_id: encodeURIComponent(unitId),
    user_id: userId,
  });
  const url = fetchFeedbackUrl({ params });
  try {
    const { data } = await getAuthenticatedHttpClient().get(url);
    return camelCaseObject(data);
  } catch (error) {
    logError(
      `Translation plugin fail to fetch from ${url}`,
      error,
    );
    return {};
  }
}

export async function createTranslationFeedback({
  courseId,
  feedbackValue,
  translationLanguage,
  unitId,
  userId,
  feedbackDetails,
  emailMe,
  reasonList,
}) {
  const createFeedbackUrl = `${
    getConfig().AI_TRANSLATIONS_URL
  }/api/v1/whole-course-translation-feedback/`;
  try {
    const { data } = await getAuthenticatedHttpClient().post(
      createFeedbackUrl,
      {
        course_id: courseId,
        feedback_value: feedbackValue,
        translation_language: translationLanguage,
        unit_id: unitId,
        user_id: userId,
        feedback_details: feedbackDetails,
        user_opt_in_for_email_discussion: emailMe,
        reason_broken: reasonList.includes(FEEDBACK_REASON_BROKEN),
        reason_harmful: reasonList.includes(FEEDBACK_REASON_HARMFUL),
        reason_not_accurate: reasonList.includes(FEEDBACK_REASON_NOT_ACCURATE),
        reason_other: reasonList.includes(FEEDBACK_REASON_OTHER),
      },
    );
    return camelCaseObject(data);
  } catch (error) {
    logError(
      `Translation plugin fail to create feedback from ${createFeedbackUrl}`,
      error,
    );
    return {};
  }
}

export async function translateUnitTitle({
  content,
  courseId,
  sourceLanguage,
  sourceTypeId,
  targetLanguage,
}) {
  const translateUnitTitleUrl = `${
    getConfig().AI_TRANSLATIONS_URL
  }/api/v1/translate-generic-content/`;
  try {
    const { data } = await getAuthenticatedHttpClient().post(
      translateUnitTitleUrl,
      {
        content,
        content_source: 'unit',
        course_id: courseId,
        source_language: sourceLanguage,
        source_type_id: sourceTypeId,
        target_language: targetLanguage,
      },
    );
    return camelCaseObject(data);
  } catch (error) {
    logError(
      `Translation plugin fail to translate title from ${translateUnitTitleUrl}`,
      error,
    );
    return {};
  }
}
